// @ts-nocheck

import './style.css'
import * as THREE from 'three'

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { PathTracingSceneWorker } from './workers/PathTracingSceneWorker'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader'
import { RectAreaLightUniformsLib } from 'three/examples/jsm/lights/RectAreaLightUniformsLib'
import {
  mergeBufferGeometries,
  mergeVertices,
} from 'three/examples/jsm/utils/BufferGeometryUtils'
import { RectAreaLightHelper } from 'three/examples/jsm/helpers/RectAreaLightHelper'
import { CSG } from 'three-csg-ts'
// import { Twist } from 'three.modifiers'
import {
  PhysicalCamera,
  PathTracingRenderer,
  PhysicalPathTracingMaterial,
} from 'three-gpu-pathtracer'
import GUI from 'lil-gui'

import { map, randomFloat, randomInt, TO_RAD } from './math'

// import characters from 'url:../public/character-6.glb'
import noise from 'url:../public/noise.png'

// import envUrl from 'url:../public/pedestrian_overpass_1k.hdr'
// import envUrl from 'url:../public/studio_small_02_1k.hdr'
import envUrl from 'url:../public/zhengyang_gate_1k.hdr'

import { ScratchShader } from './shaders/scratch'
import marbleFs from './shaders/marble.glsl'
import stoneFs from './shaders/stone.glsl'
// import sariFs from './shaders/sari.glsl'
// import mosaicFs from './shaders/mosaic.glsl'
import rawVs from './shaders/default-raw-vs.glsl'
import rawFs from './shaders/default-raw-fs.glsl'
// import triplanarFs from './shaders/triplanar.glsl'
// import tileFs from './shaders/tile.glsl'

/**
 *
 */
import { randFloat } from 'three/src/math/MathUtils'
;(async () => {
  const gui = new GUI()

  let windowHeight
  let windowWidth
  let isRendering = true
  let isFirstStop = true

  const isPortrait = true
  const isPanoramic = false
  const zoomLevel = 0.3
  const fStop = 0.1

  const envIntensityRange = [4.2, 6.5]
  const envRotationRange = [1.2, 3.9]

  // const rota = []

  // for (let i = envRotationRange[0]; i < envRotationRange[1]; i += 0.1) {
  //   rota.push(parseFloat(i.toFixed(1)))
  // }

  // const s = rota.indexOf(2.5)
  // const e = rota.indexOf(4.2)

  // rota.splice(s, e - s)

  // const rd = randomInt(0, rota.length - 1)

  const grayedFeat = (val) => {
    return val < 0.8 ? 'low' : val < 0.9 ? 'mid' : 'high'
  }

  const guiParams = {
    envRotation: randomFloat(envRotationRange[0], envRotationRange[1], 2),
    envIntensity: randomFloat(envIntensityRange[0], envIntensityRange[1], 3),
    grayed: randomFloat(0.75, 0.99, 2),
  }

  gui.add(
    guiParams,
    'envIntensity',
    envIntensityRange[0],
    envIntensityRange[1],
    0.001
  )
  gui
    .add(
      guiParams,
      'envRotation',
      envRotationRange[0],
      envRotationRange[1],
      0.1
    )
    .onChange(() => {
      rtRenderer.material.environmentRotation.setFromMatrix4(
        new THREE.Matrix4().makeRotationY(guiParams.envRotation)
      )
    })

  gui.onChange(() => {
    rtRenderer.reset()
  })

  gui.destroy()

  const isOrtho = false
  const orthoWidth = 2
  let isPreloading = true

  // window.$fxhashFeatures = {
    //   Portrait: isPortrait,
    //   FStop: fStop,
    //   'Environment intensity': guiParams.envIntensity,
    // grayed: grayedFeat(guiParams.grayed),
  // }

  if (isPortrait) {
    windowHeight = window.innerHeight
    windowWidth = (windowHeight / 4) * 3
  } else if (isPanoramic) {
    windowWidth = window.innerWidth
    windowHeight = (windowWidth / 16) * 9
  } else {
    windowWidth = window.innerWidth
    windowHeight = (windowWidth / 4) * 3
  }

  const pixelRatio = Math.min(window.devicePixelRatio, 2)
  let saveNextFrame = false

  const mouse = new THREE.Vector2()
  let bvhInfo: any

  const params = {
    bounces: 3,
    resolutionScale: 0.85,
    tiles: window.isFxpreview ? 1 : 2,
  }

  /**
   * Canvas
   */

  const CANVAS_SIZE = 1280
  let targetTab = []
  const canvasTab = []
  let matTab = []

  /**
   * Renderer
   */

  const renderer = new THREE.WebGLRenderer({
    antialias: true,
  })
  renderer.outputEncoding = THREE.sRGBEncoding
  renderer.toneMapping = THREE.ACESFilmicToneMapping

  renderer.setPixelRatio(pixelRatio * params.resolutionScale)
  renderer.setSize(windowWidth, windowHeight, false)

  renderer.domElement.id = 'three-canvas'
  document.body.appendChild(renderer.domElement)

  /**
   * Camera
   */

  const camera = new PhysicalCamera(60, windowWidth / windowHeight, 0.025, 500)
  if (isPortrait) {
    camera.position.set(
      randomFloat(
        window.fxrand < 0.1 ? -32 : 14.016119524707104,
        14.016119524707104,
        14
      ),
      randomFloat(34.08023180325502, 38.08023180325502, 14),
      randomFloat(-6.227400480035746, 33.66817563882158, 14)
    )
  } else {
    // camera.position.set(
    //   randomFloat(18.42024663213547, 31.361663989331035, 14),
    //   randomFloat(42.13739807132287, 45.21240554473169, 14),
    //   randomFloat(44.560947907859735, 46.89063274826719, 14)
    // )
  }
  camera.fStop = fStop

  camera.updateProjectionMatrix()

  const orthoHeight = orthoWidth / (windowWidth / windowHeight)
  const orthoCameraMain = new THREE.OrthographicCamera(
    orthoWidth / -2,
    orthoWidth / 2,
    orthoHeight / 2,
    orthoHeight / -2,
    0.025,
    500
  )
  orthoCameraMain.position.set(0, 5, 10)
  // orthoCameraMain.zoom = zoomLevel
  orthoCameraMain.fStop = fStop

  orthoCameraMain.updateProjectionMatrix()

  const orthoCamera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1)

  /**
   * Ray Tracing renderer
   */

  const rtRenderer = new PathTracingRenderer(renderer)
  rtRenderer.setSize(
    windowWidth * params.resolutionScale,
    windowHeight * params.resolutionScale
  )
  rtRenderer.camera = isOrtho ? orthoCameraMain : camera
  rtRenderer.tiles.set(params.tiles, params.tiles)
  rtRenderer.material = new PhysicalPathTracingMaterial()
  rtRenderer.material.defines.FEATURE_GRADIENT_BG = 1
  // rtRenderer.material.defines.FEATURE_MIS = 1
  // rtRenderer.material.bgGradientTop.set(0x3d4c53)
  // rtRenderer.material.bgGradientBottom.set(0x3d4c53)
  // rtRenderer.material.backgroundAlpha = 0

  rtRenderer.material.physicalCamera.updateFrom(camera)

  /**
   * Controls
   */

  const controls = new OrbitControls(
    isOrtho ? orthoCameraMain : camera,
    renderer.domElement
  )

  controls.target.set(
    randomFloat(24.74239401196706, 24.74239401196706, 14),
    randomFloat(13.480027756802189, 13.480027756802189, 14),
    randomFloat(21.53809283712092, 21.53809283712092, 14)
  )
  controls.update()

  controls.addEventListener('change', () => {
    console.log('position', controls.object.position)
    console.log('target', controls.target)

    rtRenderer.reset()
  })

  controls.enabled = false

  /**
   * Events
   */

  window.addEventListener('resize', onWindowResize)

  renderer.domElement.addEventListener('mousedown', onMouseDown)
  renderer.domElement.addEventListener('mouseup', onMouseUp)

  /* Material that will receive final image */

  const mat = new THREE.MeshBasicMaterial({
    map: rtRenderer.target.texture,
    transparent: true,
  })

  mat.onBeforeCompile = (shader) => {
    shader.fragmentShader = shader.fragmentShader.replace(
      '#include <clipping_planes_pars_fragment>',
      `#include <clipping_planes_pars_fragment>

        vec3 gammaCorrect(vec3 color, float gamma){
          return pow(color, vec3(1.0/gamma));
        }

        vec3 levelRange(vec3 color, float minInput, float maxInput){
            return min(max(color - vec3(minInput), vec3(0.0)) / (vec3(maxInput) - vec3(minInput)), vec3(1.0));
        }

        vec3 finalLevels(vec3 color, float minInput, float gamma, float maxInput){
            return gammaCorrect(levelRange(color, minInput, maxInput), gamma);
        }

        float contrast(float mValue, float mScale, float mMidPoint) {
          return clamp( (mValue - mMidPoint) * mScale + mMidPoint, 0.0, 1.0);
        }

        float contrast(float mValue, float mScale) {
          return contrast(mValue,  mScale, .5);
        }

        vec3 contrast(vec3 mValue, float mScale, float mMidPoint) {
          return vec3( contrast(mValue.r, mScale, mMidPoint), contrast(mValue.g, mScale, mMidPoint), contrast(mValue.b, mScale, mMidPoint) );
        }

        vec3 contrast(vec3 mValue, float mScale) {
          return contrast(mValue, mScale, .5);
        }

        float blendOverlay(float base, float blend) {
          return base<0.5?(2.0*base*blend):(1.0-2.0*(1.0-base)*(1.0-blend));
        }

        vec3 blendOverlay(vec3 base, vec3 blend) {
          return vec3(blendOverlay(base.r,blend.r),blendOverlay(base.g,blend.g),blendOverlay(base.b,blend.b));
        }

        vec3 blendOverlay(vec3 base, vec3 blend, float opacity) {
          return (blendOverlay(base, blend) * opacity + base * (1.0 - opacity));
        }`
    )

    shader.fragmentShader = shader.fragmentShader.replace(
      '#include <dithering_fragment>',
      `#include <dithering_fragment>

        vec3 gray = mix(vec3(1.), mix(gl_FragColor.rgb, vec3(dot(gl_FragColor.rgb, vec3(0.299, 0.587, 0.114) ) ) , ${guiParams.grayed}), .9);
        vec3 contrasted = contrast(gray, 1.4, 1.2);

        gl_FragColor.rgb = contrasted;`
    )
  }

  /**
   * Scene
   */

  const scene = new THREE.Scene()
  const sceneFs = new THREE.Scene()

  RectAreaLightUniformsLib.init()

  /* This plane is used to render the final image with composer */

  const meshPlane = new THREE.Mesh(new THREE.PlaneBufferGeometry(2, 2), mat)

  /**
   * Composer
   */

  const composer = new EffectComposer(renderer)
  const renderPass = new RenderPass(sceneFs, orthoCamera)
  const scratchPass = new ShaderPass(ScratchShader)

  scratchPass.uniforms.uStrength.value = randomFloat(0.01, 0.05, 3)
  scratchPass.uniforms.uRand.value = window.fxrand()

  composer.addPass(renderPass)
  composer.addPass(scratchPass)

  /**
   * BVH
   */

  const computeScene = () => {
    const generator = new PathTracingSceneWorker()
    return generator.generate(scene).then((result) => {
      const { bvh, textures, materials, lights } = result

      bvhInfo = bvh
      const geometry = bvh.geometry
      const material = rtRenderer.material

      material.bvh.updateFrom(bvh)
      material.normalAttribute.updateFrom(geometry.attributes.normal)
      material.tangentAttribute.updateFrom(geometry.attributes.tangent)
      material.uvAttribute.updateFrom(geometry.attributes.uv)

      material.materialIndexAttribute.updateFrom(
        geometry.attributes.materialIndex
      )
      material.textures.setTextures(renderer, 2048, 2048, textures)
      material.materials.updateFrom(materials, textures)

      material.lights.updateFrom(lights)
      material.lightCount = lights.length

      generator.dispose()
      // rtRenderer.reset()
    })
  }

  /**
   * Textures
   */

  const drawCanvas = () => {
    /* 0 Ball */
    const canvas = document.createElement('canvas')
    canvas.width = CANVAS_SIZE
    canvas.height = CANVAS_SIZE
    const ctx = canvas.getContext('2d')!

    ctx.fillStyle = '#ffffff'
    ctx.fillRect(0, 0, CANVAS_SIZE, CANVAS_SIZE)

    canvasTab.push(canvas)

    /* 1 Arches */
    const canvasB = document.createElement('canvas')
    canvasB.width = CANVAS_SIZE
    canvasB.height = CANVAS_SIZE
    const ctxB = canvasB.getContext('2d')!

    ctxB.fillStyle = '#969696'
    ctxB.fillRect(0, 0, CANVAS_SIZE, CANVAS_SIZE)

    canvasTab.push(canvasB)

    /* 2 Stairs */
    const canvasC = document.createElement('canvas')
    canvasC.width = CANVAS_SIZE
    canvasC.height = CANVAS_SIZE
    const ctxC = canvasC.getContext('2d')!

    ctxC.fillStyle = '#969696'
    ctxC.fillRect(0, 0, CANVAS_SIZE, CANVAS_SIZE)

    canvasTab.push(canvasC)

    /* 3 Floor */
    const canvasD = document.createElement('canvas')
    canvasD.width = CANVAS_SIZE
    canvasD.height = CANVAS_SIZE
    const ctxD = canvasD.getContext('2d')!

    ctxD.fillStyle = '#c6c6c6'
    ctxD.fillRect(0, 0, CANVAS_SIZE, CANVAS_SIZE)

    canvasTab.push(canvasD)
  }

  const canvasToTexture = async () => {
    /**
     * Add material to plane to render target because three gpu needs texture
     * Draw the 2d canvas texture with custom shader on a plane
     */

    const geo = new THREE.PlaneBufferGeometry(2, 2, 1, 1)
    const noiseTex = await new Promise((resolve) => {
      new THREE.TextureLoader().load(noise, resolve)
    })

    targetTab = canvasTab.map((canvas, i) => {
      const sceneTarget = new THREE.Scene()
      const texTarget = new THREE.WebGLRenderTarget(
        canvas.width,
        canvas.height
        // {
        //   minFilter: THREE.LinearFilter,
        //   magFilter: THREE.NearestFilter,
        // }
      )

      const tex = new THREE.CanvasTexture(canvas)

      let g = 0
      let b = 0
      const col = window.fxrand()
      if (col < 0.2) g = 1
      else if (col < 0.4) b = 1
      const material = new THREE.ShaderMaterial({
        vertexShader: rawVs,
        fragmentShader:
          i === 0
            ? marbleFs
            : i === 1
            ? stoneFs
            : // i === 2
              // ? stoneFs
              // i === 3
              // ? mosaicFs
              rawFs,
        uniforms: {
          tMap: {
            value: tex,
          },
          tNoise: {
            value: noiseTex,
          },
          uAmount: {
            value: randomFloat(0, g ? 0.2 : 0.8, 3),
          },
          uColor: {
            value: [0, g, b],
          },
          uRand: {
            value: randFloat(0.001, 0.002, 3),
          },
        },
      })

      const plane = new THREE.Mesh(geo, material)

      sceneTarget.add(plane)

      return { sceneTarget, texTarget }
    })

    /* Need to render to texture because three gpu does not support shaderMaterial */

    for (let i = 0; i < targetTab.length; i++) {
      renderer.setRenderTarget(targetTab[i].texTarget)
      renderer.render(targetTab[i].sceneTarget, orthoCamera)
    }

    renderer.setRenderTarget(null)

    /* Prepare three gpu material */

    matTab = targetTab.map((target, index) => {
      const mat = new THREE.MeshBasicMaterial({
        map: target.texTarget.texture,
        // wireframe: true,
      })

      // if (index === 1) {
      //   mat.onBeforeCompile = (shader) => {
      //     shader.vertexShader = shader.vertexShader.replace(
      //       '#include <clipping_planes_pars_vertex>',
      //       `#include <clipping_planes_pars_vertex>
      //     varying vec3 vPosition;
      //     varying vec3 vNormal;
      //     `
      //     )

      //     shader.vertexShader = shader.vertexShader.replace(
      //       '#include <fog_vertex>',
      //       `#include <fog_vertex>

      //     vNormal = normal;
      //     vPosition = position;`
      //     )

      //     shader.fragmentShader = shader.fragmentShader.replace(
      //       '#include <clipping_planes_pars_fragment>',
      //       `#include <clipping_planes_pars_fragment>

      //     varying vec3 vPosition;`
      //     )

      //     shader.fragmentShader = shader.fragmentShader.replace(
      //       '#include <dithering_fragment>',
      //       `#include <dithering_fragment>

      //       vec3 bf = normalize(abs(vNormal));
      //       bf /= dot(bf, vec3(1.0));

      //       vec2 tx = vPosition.yz * .1;
      //       vec2 ty = vPosition.zx * .1;
      //       vec2 tz = vPosition.xy * .1;

      //       vec4 cx = texture2D(map, tx) * bf.x;
      //       vec4 cy = texture2D(map, ty) * bf.y;
      //       vec4 cz = texture2D(map, tz) * bf.z;

      //       gl_FragColor = cx + cy + cz;`
      //     )
      //   }
      // }

      /**
       * Possible settings
       * materialFinal.metalness = 0.2
       * materialFinal.roughness = 0.5
       * materialFinal.transmission = 10
       * materialFinal.emissiveIntensity = 50
       * materialFinal.emissive = new THREE.Color(0xffffff)
       * mat.emissiveMap = target.texTarget.texture
       */

      // sphere
      if (index === 0) {
        mat.roughness = 0.02
        mat.metalness = 0.06
        // mat.emissiveIntensity = 0.5
        // mat.emissive = new THREE.Color(0xffffff)
      } else {
        mat.roughness = 0.5
      }

      return mat
    })

    // matTab[1].map.wrapS = matTab[1].map.wrapT = THREE.RepeatWrapping
    // matTab[2].map.repeat.set(0.25, 0.25)

    // matTab[1].map.wrapS = matTab[1].map.wrapT = THREE.ClampToEdgeWrapping

    /* Tilable */
    // const tileRenderTarget = new THREE.WebGLRenderTarget(
    //   CANVAS_SIZE,
    //   CANVAS_SIZE
    // )
    // const tileScene = new THREE.Scene()
    // tileScene.add(
    //   new THREE.Mesh(
    //     geo,
    //     new THREE.ShaderMaterial({
    //       vertexShader: rawVs,
    //       fragmentShader: triplanarFs,
    //       uniforms: {
    //         tMap: {
    //           value: targetTab[1].texTarget.texture,
    //         },
    //         uScale: {
    //           value: 0.1,
    //         },
    //       },
    //     })
    //   )
    // )

    // renderer.setRenderTarget(tileRenderTarget)
    // renderer.render(tileScene, orthoCamera)
    // renderer.setRenderTarget(null)

    // matTab[1].map = tileRenderTarget.texture
  }

  /**
   * Checker
   */

  // const canvasChecker = document.createElement('canvas')
  // const grid = 2
  // canvasChecker.width = grid * 2
  // canvasChecker.height = grid * 2
  // const ctxChecker = canvasChecker.getContext('2d')
  // ctxChecker.fillRect(0, 0, canvasChecker.width, canvasChecker.height)
  // ctxChecker.fillStyle = 'white'
  // ctxChecker.fillRect(0, 0, grid, grid)
  // ctxChecker.fillRect(grid, grid, grid, grid)

  // const mapChecker = new THREE.CanvasTexture(canvasChecker)
  // mapChecker.wrapS = mapChecker.wrapT = THREE.RepeatWrapping
  // // mapChecker.anisotropy = 16
  // mapChecker.repeat.set(5, 5)
  // // mapChecker.needsUpdate = true

  // const texChecker = new THREE.MeshBasicMaterial({ map: mapChecker })

  /**
   * Main
   */

  // sceneFs.add(meshPlaneBackground)
  sceneFs.add(meshPlane)
  // sceneFs.add(meshPlaneOverlay)

  /**
   * Events
   */

  document.addEventListener('keydown', (event) => {
    if (event.key.toLowerCase() === 's') {
      saveNextFrame = true
    } else if (event.key.toLowerCase() === 'p') {
      isRendering = !isRendering
    }
  })

  /**
   * Environment
   */

  const envPromise = new RGBELoader().loadAsync(envUrl)

  /**
   * Character
   */

  // const charLoader = new GLTFLoader().loadAsync(characters)

  const res = await Promise.all([envPromise])
  const envTex = res[0]

  envTex.mapping = THREE.EquirectangularReflectionMapping

  // scene.background = envTex
  scene.environment = envTex

  rtRenderer.material.environmentIntensity = guiParams.envIntensity
  rtRenderer.material.environmentRotation.setFromMatrix4(
    new THREE.Matrix4().makeRotationY(guiParams.envRotation)
  )
  rtRenderer.material.envMapInfo.updateFrom(envTex)

  drawCanvas()
  await canvasToTexture()

  setup()
  await computeScene()
  // controls.update()
  // setFocusPoint()

  // renderer.domElement.removeEventListener('mouseup', onMouseUp)
  // renderer.domElement.removeEventListener('mousedown', onMouseDown)

  draw()

  function generateTowerShape() {
    const mesh2 = drawTowerShape({ door: 2 })
    const mesh1 = drawTowerShape({ door: 1 })
    const mesh0 = drawTowerShape({ door: 0 })

    return [mesh0, mesh1, mesh2]
  }

  function drawTowerShape({ height = 5, door } = {}) {
    // const shape = new THREE.Shape()
    // shape.moveTo(0, 0)
    // shape.lineTo(0, height)
    // shape.lineTo(4, height)
    // shape.lineTo(4, 0)
    // shape.lineTo(0, 0)

    // const hole = new THREE.Path()
    // hole.moveTo(1, 1)
    // hole.lineTo(1, 3)
    // hole.absarc(2, 3, 1, Math.PI, 0, true)
    // hole.lineTo(3, 1)
    // hole.lineTo(1, 1)

    // shape.holes = [hole]

    const extrudeSettings = {
      depth: 4,
      bevelEnabled: false,
    }

    // const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings)

    const geometry = new THREE.BoxBufferGeometry(4, height, 4)

    const mesh = new THREE.Mesh(geometry, matTab[3])
    mesh.position.set(2, height / 2, 2)
    mesh.updateMatrix()

    if (door === 0) return mesh

    const archShape = new THREE.Shape()
    archShape.moveTo(0, 0)
    archShape.lineTo(0, 2)
    archShape.absarc(1, 2, 1, Math.PI, 0, true)
    archShape.lineTo(2, 0)
    archShape.lineTo(0, 0)

    const archGeometry = new THREE.ExtrudeGeometry(
      archShape,
      Object.assign(extrudeSettings, { depth: 6 })
    )

    const archMesh = new THREE.Mesh(archGeometry, matTab[1])
    archMesh.rotateY(90 * TO_RAD)
    archMesh.position.set(-1, 1, 3)
    // scene.add(archMesh)
    archMesh.updateMatrix()

    const clone = archMesh.clone()
    clone.rotateY(90 * TO_RAD)
    clone.position.set(3, 1, 5)
    // scene.add(clone)
    clone.updateMatrix()

    // mesh.updateMatrix()

    const subRes = CSG.subtract(mesh, archMesh)

    if (door === 1) return subRes

    const subRes2 = CSG.subtract(subRes, clone)

    return subRes2
  }

  function randomTower({ meshTab, height }) {
    const grouped = new THREE.Group()
    const tabOrga = []

    for (let i = 0; i < height; i += 5) {
      const rd = window.fxrand()

      let meshDoor

      if (rd < 0.2) {
        meshDoor = meshTab[2].clone()
        tabOrga.push(3)
      } else if (rd < 0.4) {
        meshDoor = meshTab[1].clone()
        const rdRota = window.fxrand() < 0.5
        meshDoor.rotation.y = rdRota ? 90 * TO_RAD : 0
        tabOrga.push(window.fxrand() < 0.5 ? 1 : 2)
      } else {
        meshDoor = meshTab[0].clone()
        tabOrga.push(0)
      }

      meshDoor.position.y = i + 2.5

      grouped.add(meshDoor)
    }

    return { mesh: grouped, orga: tabOrga }
  }

  function drawStairs({
    steps = 8,
    fill = true,
    multiplierW = 0.5,
    multiplierH = 0.5,
    depth = 4,
  } = {}) {
    const shape = new THREE.Shape()

    shape.moveTo(0, 0)

    for (let i = 0; i < steps; i++) {
      shape.lineTo(i * multiplierW, (i + 1) * multiplierW * multiplierH)
      shape.lineTo((i + 1) * multiplierW, (i + 1) * multiplierW * multiplierH)
    }

    shape.lineTo(
      steps * multiplierW,
      fill ? 0 : steps * multiplierW - 1 * multiplierW
    )
    // shape.lineTo(0, 0)
    shape.closePath()

    const extrudeSettings = {
      depth,
      bevelEnabled: false,
    }

    const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings)

    // console.log(matTab[4])
    // matTab[4].map.wrapS = matTab[4].map.wrapT = THREE.RepeatWrapping
    // matTab[4].map.repeat.set(0.25, 0.25)
    // matTileable.map.needsUpdate = true

    // const clonedMat = texChecker.clone()
    // const clonedTex = texChecker.map.clone()
    // clonedMat.map = clonedTex
    // clonedTex.repeat.set(1, 1)

    const mesh = new THREE.Mesh(geometry, matTab[3])

    return mesh
  }

  function setup() {
    const floor = new THREE.PlaneBufferGeometry(800, 800)
    floor.rotateX(-90 * TO_RAD)
    scene.add(new THREE.Mesh(floor, matTab[3]))

    const meshTab = generateTowerShape()

    const GRID_SIZE = 4
    const tabOrga = []

    for (let i = 0; i < 10; i++) {
      for (let j = 0; j < 10; j++) {
        if (window.fxrand() > 0.7) continue

        let rdHeight = randomInt(i * 2, i * 4)
        rdHeight = rdHeight % 5 === 0 ? rdHeight : rdHeight - (rdHeight % 5)
        const { mesh, orga } = randomTower({
          height: rdHeight,
          meshTab,
        })
        if (!tabOrga[i]) tabOrga[i] = []
        tabOrga[i][j] = orga
        mesh.children.forEach((child) => {
          child.position.x += i * GRID_SIZE
          child.position.z += j * GRID_SIZE
        })
        // mesh.position.set(i * 12, 0, j * 12)
        scene.add(mesh)

        const rdTypeTop = window.fxrand()
        const rdRotaStairs = window.fxrand()
        if (rdTypeTop < 0.5) {
          const num = [8, 16]
          const rdSteps = num[randomInt(0, num.length - 1)]
          const stair = drawStairs({
            steps: rdSteps,
            multiplierW: map(rdSteps, 8, 16, 0.5, 0.25),
          })

          stair.position.set(i * GRID_SIZE, rdHeight, j * GRID_SIZE)

          if (rdRotaStairs < 0.25) {
            stair.rotateY(90 * TO_RAD)
            stair.translateX(-4)
          } else if (rdRotaStairs < 0.5) {
            stair.rotateY(-90 * TO_RAD)
            stair.translateZ(-4)
          } else if (rdRotaStairs < 0.75) {
            stair.rotateY(180 * TO_RAD)
            stair.translateZ(-4)
            stair.translateX(-4)
          }

          // stair.geometry.applyMatrix4(new THREE.Matrix4().makeTranslation(-2, 3, -2))
          // stair.updateMatrix()
          scene.add(stair)

          // const mergedGeo = mergeBufferGeometries([
          //   mesh.geometry.toNonIndexed(),
          //   stair.geometry.toNonIndexed(),
          // ])
          // const mergedVertices = mergeVertices(mergedGeo)
          // scene.add(new THREE.Mesh(mergedVertices, matTab[1]))
        } else if (rdTypeTop < 0.7) {
          const radius = randomFloat(0.6, 2, 2)
          const ball = new THREE.Mesh(
            new THREE.SphereBufferGeometry(radius, 32, 32),
            matTab[0]
          )
          // matTab[0].uniforms.uColor.value = [0, 0, 0]
          ball.position.set(
            i * GRID_SIZE + 2,
            rdHeight + radius,
            j * GRID_SIZE + 2
          )
          scene.add(ball)
        }
      }
    }

    // add arck
    // const modifier = new ModifierStack(mesh)
    // const twist = new Twist(0)
    // twist.vector = new THREE.Vector3(0, 1, 0)
    // modifier.addModifier(twist)
    // modifier && modifier.apply()

    /* Light */

    const lightColors = [0xe3ba9c, 0xf4aa49, 0x0d35ae, 0x2a5c3f]

    const rectLight = new THREE.RectAreaLight(
      new THREE.Color(0x0000ff),
      randomInt(50, 90),
      20,
      10
    )
    rectLight.position.set(20, 35, 45)
    rectLight.lookAt(20, 0, 0)
    scene.add(rectLight)
    // rectLight.visible = false
    // const rectLightHelper = new RectAreaLightHelper(rectLight)
    // rectLight.add(rectLightHelper)

    rtRenderer.material.lights.updateFrom([rectLight])
  }

  function draw() {
    const rafId = requestAnimationFrame(draw)

    if (isRendering) {
      rtRenderer.material.environmentIntensity = guiParams.envIntensity //rmv !!
      controls.update()
      // renderer.render(targetTab[0].sceneTarget, camera)
      // renderer.render(scene, camera)
      rtRenderer.update()
      composer.render()
    }

    if (Math.floor(rtRenderer.samples) > 80 && window.isFxpreview) {
      window.fxpreview()
      cancelAnimationFrame(rafId)
    } else if (
      Math.floor(rtRenderer.samples) > 100 &&
      isRendering &&
      isFirstStop
    ) {
      isRendering = isFirstStop = false
    }

    if (Math.floor(rtRenderer.samples) > 1 && isPreloading) {
      isPreloading = false
      document.querySelector('.pre').classList.add('is-hidden')
    }

    if (saveNextFrame) {
      saveNextFrame = false
      const can = document.querySelector('#three-canvas') as HTMLCanvasElement
      const dataURL = can.toDataURL('image/png')
      const link = document.createElement('a')
      link.download = `jantar-mantar-${Date.now()}.png`
      link.href = dataURL
      link.click()
    }
  }

  function onWindowResize() {
    if (isPortrait) {
      windowHeight = window.innerHeight
      windowWidth = (windowHeight / 4) * 3
    } else if (isPanoramic) {
      windowWidth = window.innerWidth
      windowHeight = (windowWidth / 16) * 9
    } else {
      windowWidth = window.innerWidth
      windowHeight = (windowWidth / 4) * 3
    }

    const aspect = windowWidth / windowHeight

    camera.aspect = aspect
    camera.updateProjectionMatrix()

    const orthoHeight = orthoWidth / aspect
    orthoCameraMain.top = orthoHeight / 2
    orthoCameraMain.bottom = orthoHeight / -2
    orthoCameraMain.updateProjectionMatrix()

    renderer.setSize(windowWidth, windowHeight, false)

    rtRenderer.target.setSize(
      windowWidth * params.resolutionScale * pixelRatio,
      windowHeight * params.resolutionScale * pixelRatio
    )

    rtRenderer.reset()
  }

  function setFocusPoint() {
    const md = new Event('mousedown')
    const mu = new Event('mouseup')

    // md.clientX = mu.clientX = windowWidth
    // md.clientY = mu.clientY = windowHeight

    renderer.domElement.dispatchEvent(md)
    renderer.domElement.dispatchEvent(mu)
  }

  function onMouseDown(e: MouseEvent) {
    mouse.set(e.clientX, e.clientY)
  }

  function onMouseUp(e: MouseEvent) {
    const deltaMouse =
      Math.abs(mouse.x - e.clientX) + Math.abs(mouse.y - e.clientY)

    if (deltaMouse < 2) {
      const raycaster = new THREE.Raycaster()
      raycaster.setFromCamera(
        {
          x:
            ((e.clientX - (window.innerWidth - windowWidth) / 2) /
              windowWidth) *
              2 -
            1,
          y:
            -(
              (e.clientY - (window.innerHeight - windowHeight) / 2) /
              windowHeight
            ) *
              2 +
            1,
        },
        isOrtho ? orthoCameraMain : camera
      )

      const hit = bvhInfo.raycastFirst(raycaster.ray)

      if (hit) {
        camera.focusDistance = hit.distance - camera.near
        rtRenderer.material.physicalCamera.updateFrom(camera)

        rtRenderer.reset()
      }
    }
  }
})()
